import http, { url } from '../../http'

const API_URL = "identification_substances_carcinogens"

class identificacionSustanciasAPI {

  async save(highdirection) {
    const response = await http(`${API_URL}/save`, 'POST', highdirection)
    return response
  }
  async saveH(highdirection) {
    const response = await http(`security_sheets/save`, 'POST', highdirection)
    return response
  }
 
  async getAllIdentification() {
    const response = await http(`${API_URL}`)
    return response
  } 

  async getActa() {
    return url(`highdirection`)
  } 

  async getAllIdentificationCompany(id,  page) {
    const response = await http(`${API_URL}/company/${id}?page=${page}`)
    return response
  } 
 
  async get(id) {
    const response = await http(`${API_URL}/index/${id}`,  'POST')
    return response
  }

  async getH(id, hojas) {
    const response = await http(`security_sheets/index/${id}/${hojas}`,  'POST')
    return response
  }

  async getShow(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  }

  async getShowH(id) {
    const response = await http(`security_sheets/show/${id}`)
    return response
  }
  async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`,  'POST')
    return response
  } 

  async getAllH(id, hojas, page, search) {
    const response = await http(`security_sheets/index/${id}/${hojas}?page=${page}&search=${search}`,  'POST')
    return response
  } 



  async update(id, revision) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', revision)
    return response
  }

  async updateH(id, revision) {
    const response = await http(`security_sheets/update/${id}`, 'PUT', revision)
    return response
  }
  async deletePlanificacion(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  async deleteH(id) {
    const response = await http(`security_sheets/delete/${id}`, 'DELETE')
    return response
  }

 
  
}

export default new identificacionSustanciasAPI()